export interface FolderNameValidation {
  valid: boolean;
  value: string;
  error?: string;
}

const MAX_LEN = 255;

// Strip C0 controls (0x00-0x1F), DEL + C1 (0x7F-0x9F), and Unicode
// bidi/direction-override controls — mirrors the server name rule.
const DIRECTION_OVERRIDE_CODEPOINTS = new Set<number>([
  0x200e, // LEFT-TO-RIGHT MARK
  0x200f, // RIGHT-TO-LEFT MARK
  0x202a, // LEFT-TO-RIGHT EMBEDDING
  0x202b, // RIGHT-TO-LEFT EMBEDDING
  0x202c, // POP DIRECTIONAL FORMATTING
  0x202d, // LEFT-TO-RIGHT OVERRIDE
  0x202e, // RIGHT-TO-LEFT OVERRIDE
  0x2066, // LEFT-TO-RIGHT ISOLATE
  0x2067, // RIGHT-TO-LEFT ISOLATE
  0x2068, // FIRST STRONG ISOLATE
  0x2069, // POP DIRECTIONAL ISOLATE
]);

function stripDisallowed(raw: string): string {
  let out = "";
  for (const ch of raw) {
    const cp = ch.codePointAt(0);
    if (cp === undefined) {
      continue;
    }
    const isControl = cp <= 0x1f || (cp >= 0x7f && cp <= 0x9f);
    if (isControl || DIRECTION_OVERRIDE_CODEPOINTS.has(cp)) {
      continue;
    }
    out += ch;
  }
  return out;
}

/**
 * Normalize + validate a folder name the same way the server does, so the
 * "Create" button disables on exactly the inputs the server would reject.
 */
export function validateFolderName(raw: string): FolderNameValidation {
  const value = stripDisallowed(raw).trim();

  if (value.length === 0) {
    return { valid: false, value, error: "Folder name is required." };
  }
  if (value.length > MAX_LEN) {
    return {
      valid: false,
      value,
      error: `Folder name must be ${MAX_LEN} characters or fewer.`,
    };
  }
  return { valid: true, value };
}
